import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';
import { UserService } from '@app/core';
import { Rol } from '@app/core/model/rol.model';
import { User } from '@app/core/model/user.model';
import { CodeNode } from 'source-list-map';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
